const TEARDOWN_ERROR_NAMES = new Set([
  "NetworkError",
  "NotFoundError",
  "InvalidStateError",
  "AbortError",
]);

const TEARDOWN_MESSAGE_PATTERNS = [
  /transferIn/i,
  /transferOut/i,
  /device (?:was |has been )?(?:disconnected|lost)/i,
  /socket closed/i,
];

export function isExpectedUsbTeardownError(error: unknown): boolean {
  if (error === null || error === undefined) return false;

  const name = (error as { name?: unknown }).name;
  if (typeof name === "string" && TEARDOWN_ERROR_NAMES.has(name)) return true;

  const message = (error as { message?: unknown }).message;
  const text = typeof message === "string" ? message : String(error);
  return TEARDOWN_MESSAGE_PATTERNS.some((pattern) => pattern.test(text));
}

const USB_TRANSFER_FAILURE = /Failed to execute 'transfer(?:In|Out)' on 'USBDevice'/;

export function isUsbTransferFailureReport(message: string): boolean {
  return USB_TRANSFER_FAILURE.test(message);
}
